import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import CreateRepository from '../Repositories/CreateRepository'

class CreateBloc {

    createChannel = new Subject()
    menuChannel = new Subject()
    repository = new CreateRepository()

    constructor() {
        this.createChannel.next({ status: apiResponse.INITIAL })
        this.menuChannel.next({ status: apiResponse.INITIAL })
    }

    fetchCreate = async (query) => {
        this.createChannel.next({ status: apiResponse.LOADING })
        await this.repository.fetchCreate(query).then((result) => {
            this.createChannel.next({ status: apiResponse.COMPLETED, data: result })
        }).catch((error) => {
            this.createChannel.next({ status: apiResponse.ERROR, data: error })
        })
    }

    fetchMenu = async (query) => {
        this.menuChannel.next({ status: apiResponse.LOADING })
        await this.repository.fetchMenu(query).then((result) => {
            this.menuChannel.next({ status: apiResponse.COMPLETED, data: result })
        }).catch((error) => {
            this.menuChannel.next({ status: apiResponse.ERROR, data: error })
        })
    }

}

export default CreateBloc